import { createFileRoute } from '@tanstack/react-router';
import { BusinessHoursPage } from '../../features/settings/components/business-hours-page.js';

export const Route = createFileRoute('/admin/hours')({ component: BusinessHoursPage });
